import script from "./FunerariaDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./FunerariaDashboard.vue?vue&type=script&setup=true&lang=js"

import "./FunerariaDashboard.vue?vue&type=style&index=0&id=0d3daf7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d3daf7a"]])

export default __exports__